module.exports = __webpack_public_path__ + "h5/img/wufu1@2x.be8c809c.png";